import { UsersIcon, EyeIcon, ArrowTrendingUpIcon, DevicePhoneMobileIcon } from '@heroicons/react/24/outline';

interface Props {
  totalPageViews: number;
  totalSessions: number;
  avgPagesPerSession: number;
  mobilePercent: number;
  newVisitorPercent: number;
  bounceRate: number;
}

export default function AnalyticsOverview({
  totalPageViews,
  totalSessions,
  avgPagesPerSession,
  mobilePercent,
  newVisitorPercent,
  bounceRate,
}: Props) {
  const stats = [
    {
      label: 'Page Views',
      value: totalPageViews.toLocaleString(),
      icon: EyeIcon,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
    },
    {
      label: 'Sessions',
      value: totalSessions.toLocaleString(),
      icon: UsersIcon,
      color: 'text-green-600',
      bg: 'bg-green-50',
    },
    {
      label: 'Pages / Session',
      value: avgPagesPerSession.toFixed(1),
      icon: ArrowTrendingUpIcon,
      color: 'text-golf-orange',
      bg: 'bg-orange-50',
    },
    {
      label: 'Mobile',
      value: `${mobilePercent.toFixed(0)}%`,
      icon: DevicePhoneMobileIcon,
      color: 'text-teal-600',
      bg: 'bg-teal-50',
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map(s => (
        <div key={s.label} className="bg-white rounded-xl border border-gray-200 p-5 flex items-center space-x-4">
          <div className={`${s.bg} p-3 rounded-lg flex-shrink-0`}>
            <s.icon className={`w-5 h-5 ${s.color}`} />
          </div>
          <div>
            <p className="text-xs text-gray-500 font-medium">{s.label}</p>
            <p className="text-2xl font-bold text-gray-900 font-display">{s.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
